import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-input date-input" }
const _hoisted_2 = ["for"]

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateInput',
  props: {
    id: {},
    label: {},
    value: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {





// South African convention: "Tue 28 Jul 2026".
const displayFormat = (date: Date): string =>
  date.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).replace(/,/g, '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "label-primary z-10",
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createVNode(_unref(VueDatePicker), {
      uid: _ctx.id,
      "model-value": _ctx.value,
      format: displayFormat,
      "enable-time-picker": false,
      "auto-apply": "",
      clearable: true,
      placeholder: "Any date",
      teleport: true,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:value', $event)))
    }, null, 8, ["uid", "model-value"])
  ]))
}
}

})